import * as XLSX from 'xlsx'

function makeSheet(headers, rows) {
  return XLSX.utils.aoa_to_sheet([headers, ...rows])
}

export function exportCallLogs(callLogs) {
  const headers = ['Date', 'Time', 'Agent', 'Prospect Name', 'Title', 'Company', 'Industry',
    'Outcome', 'BANT Score', 'Lead Status', 'Meeting Set', 'Passed to AM', 'Notes', 'Follow-up Date', 'Next Action']
  const rows = callLogs.map(r => [
    r.call_date, r.call_time, r.agent, r.prospect_name, r.title, r.company,
    r.industry, r.outcome, r.bant_score, r.lead_status, r.meeting_set,
    r.passed_to_am, r.notes, r.follow_up_date, r.next_action,
  ])
  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, makeSheet(headers, rows), 'Call Log')
  XLSX.writeFile(wb, 'ICS_Call_Log.xlsx')
}

export function exportPipeline(pipeline) {
  const headers = ['Agent', 'Prospect', 'Company', 'Solution', 'Est. Value',
    'BANT Score', 'Stage', 'AM Assigned', 'Meeting Date', 'Brief']
  const rows = pipeline.map(r => [
    r.agent, r.prospect_name, r.company, r.solution, r.est_value,
    r.bant_score, r.stage, r.am_assigned, r.meeting_date, r.brief,
  ])
  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, makeSheet(headers, rows), 'Pipeline')
  XLSX.writeFile(wb, 'ICS_Pipeline.xlsx')
}

export function exportMonthly(callLogs, AGENTS, MONTHLY_TARGETS) {
  const headers = ['Agent', 'Total Calls', 'Target Calls', '% Achieved', 'Meetings Set', 'BANT Leads (≥3)']
  const rows = AGENTS.map(a => {
    const t = MONTHLY_TARGETS[a]
    const calls = callLogs.filter(r => r.agent === a).length
    const meetings = callLogs.filter(r => r.agent === a && r.meeting_set === 'Yes').length
    const bant = callLogs.filter(r => r.agent === a && r.bant_score >= 3).length
    return [a, calls, t.calls, t.calls > 0 ? Math.round(calls / t.calls * 100) + '%' : '–', meetings, bant]
  })
  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, makeSheet(headers, rows), 'Monthly Summary')
  XLSX.writeFile(wb, 'ICS_Monthly_Summary.xlsx')
}

export function exportDatabase(contacts) {
  const headers = ['Name', 'Title', 'Company', 'Industry', 'Status', 'Agent']
  const rows = contacts.map(r => [r.name, r.role, r.company, r.industry, r.status, r.agent])
  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, makeSheet(headers, rows), 'Database')
  XLSX.writeFile(wb, 'ICS_Database.xlsx')
}

export function exportAll(callLogs, pipeline, reminders, AGENTS, MONTHLY_TARGETS, DATABASE_CONTACTS) {
  const wb = XLSX.utils.book_new()
  const today = new Date().toISOString().slice(0, 10)

  XLSX.utils.book_append_sheet(wb, makeSheet(
    ['Date', 'Time', 'Agent', 'Prospect', 'Title', 'Company', 'Industry', 'Outcome', 'BANT', 'Status', 'Meeting', 'AM', 'Notes', 'Follow-up', 'Next Action'],
    callLogs.map(r => [r.call_date, r.call_time, r.agent, r.prospect_name, r.title, r.company, r.industry, r.outcome, r.bant_score, r.lead_status, r.meeting_set, r.passed_to_am, r.notes, r.follow_up_date, r.next_action])
  ), 'Call Log')

  XLSX.utils.book_append_sheet(wb, makeSheet(
    ['Agent', 'Prospect', 'Company', 'Solution', 'Est. Value', 'BANT', 'Stage', 'AM', 'Meeting Date', 'Brief'],
    pipeline.map(r => [r.agent, r.prospect_name, r.company, r.solution, r.est_value, r.bant_score, r.stage, r.am_assigned, r.meeting_date, r.brief])
  ), 'Pipeline')

  XLSX.utils.book_append_sheet(wb, makeSheet(
    ['Agent', 'Prospect', 'Company', 'Follow-up Date', 'Time', 'Priority', 'Notes', 'Status'],
    reminders.map(r => [r.agent, r.prospect_name, r.company, r.follow_up_date, r.follow_up_time, r.priority, r.notes, r.done ? 'Done' : 'Pending'])
  ), 'Reminders')

  XLSX.utils.book_append_sheet(wb, makeSheet(
    ['Agent', 'Total Calls', 'Target', '% Achieved', 'Meetings', 'BANT Leads'],
    AGENTS.map(a => {
      const t = MONTHLY_TARGETS[a]
      const c = callLogs.filter(r => r.agent === a).length
      const m = callLogs.filter(r => r.agent === a && r.meeting_set === 'Yes').length
      const b = callLogs.filter(r => r.agent === a && r.bant_score >= 3).length
      return [a, c, t.calls, t.calls > 0 ? Math.round(c / t.calls * 100) + '%' : '–', m, b]
    })
  ), 'Monthly Summary')

  XLSX.utils.book_append_sheet(wb, makeSheet(
    ['Name', 'Title', 'Company', 'Industry', 'Status', 'Agent'],
    DATABASE_CONTACTS.map(r => [r.name, r.role, r.company, r.industry, r.status, r.agent])
  ), 'Database')

  XLSX.writeFile(wb, `ICS_Telesales_Tracker_${today}.xlsx`)
}
